import {
  MODAL_401_CLEAR,
  MODAL_CLEAN_UP,
  MODAL_CLOSE,
  MODAL_OPEN,
  MODAL_WINDOW_POPSTATE,
} from '@app/store/actionTypes';

import { ModalType } from './types';

export function modalCleanUp() {
  return {
    type: MODAL_CLEAN_UP,
  };
}

export function modalClose(modalId?: string) {
  return {
    type: MODAL_CLOSE,
    payload: { modalId },
  };
}

export function modalOpen(modalType: ModalType, modalProps = {}) {
  return {
    type: MODAL_OPEN,
    payload: {
      modalType,
      modalProps,
    },
  };
}

/**
 * 모달이 오픈된 상태에서 브라우저 이동(뒤로, 앞으로) 이벤트(modalWindowPopstate),
 * HTTP 응답 401 이벤트(modalUnauthorizedClosed) 처리를 위한 액션입니다.
 * Window.popstate 이벤트 발생 시 사용합니다.
 * 일반적인 상황에서는 MODAL_CLEAN_UP 액션을 사용합니다.
 */
export function modalUnauthorizedClose() {
  return {
    type: MODAL_401_CLEAR,
  };
}

export function modalWindowPopstate() {
  return {
    type: MODAL_WINDOW_POPSTATE,
  };
}

export type ModalAction =
  | ReturnType<typeof modalCleanUp>
  | ReturnType<typeof modalClose>
  | ReturnType<typeof modalOpen>
  | ReturnType<typeof modalUnauthorizedClose>
  | ReturnType<typeof modalWindowPopstate>;
